import { ref } from "vue"
import currencyUtils from "@/helpers/currencyUtils"

export type SupportedCountry = "US" | "CA"

export function getCurrencyByCountry(country: SupportedCountry): string {
  switch (country) {
    case "CA":
      return "CAD"
    case "US":
    default:
      return "USD"
  }
}

function getCurrencyFromWindow(): string {
  try {
    const billingCurrency = (window as any).FinancialCents?.company?.billing_currency
    if (billingCurrency === "cad") {
      return "CAD"
    }
    if (billingCurrency === "usd") {
      return "USD"
    }
  } catch (error) {
    console.error("Error reading currency from window:", error)
  }
  return "USD"
}

export function useCurrencyFormat() {
  const currency = ref<string>(getCurrencyFromWindow())

  return {
    currency,
    calculateTax: currencyUtils.calculateTax,
    calculateTotal: currencyUtils.calculateTotal,
    convertToCents: currencyUtils.convertToCents,
    convertFromCents: currencyUtils.convertFromCents,
    calculatePercentageDiscount: currencyUtils.calculatePercentageDiscount,
    calculateRate: currencyUtils.calculateRate,
    addAmounts: currencyUtils.addAmounts,
    formatCurrencyCompact: currencyUtils.formatCurrencyCompact,
    formatCurrency: (amount: number | null | undefined, locale?: string) => {
      if (amount === null || amount === undefined) return ""
      return currencyUtils.formatCurrency(amount, currency.value, locale)
    },
    formatCurrencyWithoutCents: (amount: number | null | undefined, locale?: string) => {
      if (amount === null || amount === undefined) return ""
      return currencyUtils.formatCurrencyWithoutCents(amount, currency.value, locale)
    },
    convertAndFormatCurrency: (amount: number | null | undefined) => {
      if (amount === null || amount === undefined) return ""
      return currencyUtils.convertAndFormatCurrency(amount, currency.value)
    },
  }
}
